import request from '@/utils/request'

export function getAvatarLink(cifid) {
  return request({ url: 'vgetavatarlink', method: 'get', params: { cifid } })
}
